import type { Query } from '@kentik/ui-shared/query/query.types';
import type { PendingUdeQuery } from 'app/views/boards/panels/ude/form.types';
import { action, observable, when } from 'mobx';
import QueryModel, { QuerySettings } from './QueryModel';

class UdeStore {
  @observable flowVariant = 'a';

  ude = {
    id: '',
    name: '',
    description: '',
    createdAt: '',
    updatedAt: ''
  };

  pendingQuery: PendingUdeQuery | null = null;

  @action
  setFlowVariant(variant: string) {
    this.flowVariant = variant;
  }

  async runQuery(query: Query): Promise<QueryModel> {
    const settings: QuerySettings = { chart: {} };
    const model = new QueryModel(query, settings);
    await model.run();
    await when(() => !model.isLoading);
    model.cleanup();
    if (model.hasError) {
      throw new Error('UDE query failed');
    }
    return model;
  }

  /** Stash a query + chart settings for navigation to the UDE page. */
  setPendingQuery(pending: PendingUdeQuery) {
    this.pendingQuery = pending;
  }

  /** One-shot read of the stashed pending query. Returns and clears it. */
  consumePendingQuery(): PendingUdeQuery | null {
    const pending = this.pendingQuery;
    this.pendingQuery = null;
    return pending;
  }
}

export default new UdeStore();
